'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class;

var _servicesCore = require('@makerdao/services-core');

var _contracts = require('../../contracts/contracts');

var _contracts2 = _interopRequireDefault(_contracts);

var _Currency = require('./Currency');

var _tracksTransactions = require('../utils/tracksTransactions');

var _tracksTransactions2 = _interopRequireDefault(_tracksTransactions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// FIXME we should probably just get rid of this service entirely and move the
// functions into WethToken and PethToken

var TokenConversionService = (_class = function (_PrivateService) {
  (0, _inherits3.default)(TokenConversionService, _PrivateService);

  function TokenConversionService() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'conversion';
    (0, _classCallCheck3.default)(this, TokenConversionService);
    return (0, _possibleConstructorReturn3.default)(this, (TokenConversionService.__proto__ || (0, _getPrototypeOf2.default)(TokenConversionService)).call(this, name, ['smartContract', 'token', 'allowance']));
  }

  (0, _createClass3.default)(TokenConversionService, [{
    key: '_getToken',
    value: function _getToken(token) {
      return this.get('token').getToken(token);
    }
  }, {
    key: 'convertEthToWeth',
    value: function convertEthToWeth(amount, options) {
      return this._getToken(_Currency.WETH).deposit(amount, options);
    }
  }, {
    key: 'convertWethToPeth',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(amount) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$unit = _ref2.unit,
            unit = _ref2$unit === undefined ? _Currency.WETH : _ref2$unit,
            promise = _ref2.promise;

        var pethContract;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pethContract = this._getToken(_Currency.PETH);
                _context.next = 3;
                return this.get('allowance').requireAllowance(_Currency.WETH, this.get('smartContract').getContractByName(_contracts2.default.SAI_TUB).address, { promise: promise });

              case 3:
                return _context.abrupt('return', pethContract.join(amount, { unit: unit, promise: promise }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function convertWethToPeth(_x2) {
        return _ref.apply(this, arguments);
      }

      return convertWethToPeth;
    }()
  }, {
    key: 'convertEthToPeth',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(value, _ref4) {
        var promise = _ref4.promise;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.convertEthToWeth(value, { promise: promise });

              case 2:
                return _context2.abrupt('return', this.convertWethToPeth(value, { promise: promise }));

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function convertEthToPeth(_x4, _x5) {
        return _ref3.apply(this, arguments);
      }

      return convertEthToPeth;
    }()
  }, {
    key: 'convertWethToEth',
    value: function convertWethToEth(amount, options) {
      return this._getToken(_Currency.WETH).withdraw(amount, options);
    }
  }, {
    key: 'convertPethToWeth',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(amount, _ref6) {
        var _ref6$unit = _ref6.unit,
            unit = _ref6$unit === undefined ? _Currency.WETH : _ref6$unit,
            promise = _ref6.promise;
        var pethToken;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                pethToken = this._getToken(_Currency.PETH);
                _context3.next = 3;
                return this.get('allowance').requireAllowance(_Currency.PETH, this.get('smartContract').getContractByName(_contracts2.default.SAI_TUB).address, { promise: promise });

              case 3:
                return _context3.abrupt('return', pethToken.exit(amount, { unit: unit, promise: promise }));

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function convertPethToWeth(_x6, _x7) {
        return _ref5.apply(this, arguments);
      }

      return convertPethToWeth;
    }()
  }, {
    key: 'convertPethToEth',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(amount, _ref8) {
        var promise = _ref8.promise;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.convertPethToWeth(amount, { promise: promise });

              case 2:
                return _context4.abrupt('return', this.convertWethToEth(amount, { promise: promise }));

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function convertPethToEth(_x8, _x9) {
        return _ref7.apply(this, arguments);
      }

      return convertPethToEth;
    }()
  }]);
  return TokenConversionService;
}(_servicesCore.PrivateService), (_applyDecoratedDescriptor(_class.prototype, 'convertWethToPeth', [_tracksTransactions2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'convertWethToPeth'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'convertEthToPeth', [_tracksTransactions2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'convertEthToPeth'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'convertPethToWeth', [_tracksTransactions2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'convertPethToWeth'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'convertPethToEth', [_tracksTransactions2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'convertPethToEth'), _class.prototype)), _class);
exports.default = TokenConversionService;